<c-card *transloco="let t">
  <c-card-body>
    <c-container>

      <c-row>
        <c-col md="4">
          <h1>{{ t('Update Alert Loop') }}</h1>
        </c-col>
        <c-col md="8">
          <c-row class="justify-content-end">
            <c-col xs="auto">

              <div class="btn-group mb-2 " role="group">
                <button color="light" cButton  routerLink="/mgmt/alertloops/alertloops">
                  <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                  {{ t('Return to Alert Loops') }}
                </button>
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35352962127377-Alert-Loops-Sequenced-Monitor-Alerts" role="button" target="_new"><i class="fa-regular fa-circle-question"></i> {{ t('Help') }}</a>
                <button cButton color="danger" class="text-white" (click)="doDelete()">
                  <i class="fa-solid fa-x"></i> {{ t('Delete') }}
                </button>
            </div>

            </c-col>
            <c-row class="justify-content-end">
              <c-col xs="auto">

              </c-col>
              <c-col xs="auto">

              </c-col>
            </c-row>
          </c-row>
        </c-col>
      </c-row>
      <ng-container *ngIf="alertloop">
        <c-card>
          <c-card-header>
            <c-row>
            <c-col>
              <h2>
                <b>{{alertloop.name}}</b>
              </h2>
            </c-col>
            <c-col class="text-end">

              <button  type="button" class="btn btn-info mb-2 me-2 text-white" data-bs-toggle="modal" data-bs-target="#editLoopModal">
                <svg cIcon class="me-2" name="cil-pencil"></svg> {{ t('Edit Loop') }}
              </button>


                <button  type="button" class="btn btn-success mb-2 text-white" data-bs-toggle="modal" data-bs-target="#addStepModal">
                  <svg cIcon class="me-2" name="cil-plus"></svg> {{ t('Add a Step') }}
                </button>
            </c-col>
          </c-row>
          </c-card-header>
          <c-card-body>
            <c-row>
              <ul class="list-group p-2">
              <ng-container *ngFor="let step of alertloop.steps, let i = index" >

                <li class="list-group-item list-group-item-light">
                  <div class="float-end">
                    <div class="btn-group" role="group" aria-label="...">
                      <button class="btn btn-outline-secondary" role="button" (click)="removeStep(i)" *ngIf="alertloop.steps.length > 1"><i class="fa fa-times" aria-hidden="true"></i></button>
                      <button class="btn btn-outline-secondary" role="button"  (click)="swap(alertloop.steps,i,(i-1))" *ngIf="i > 0"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                      <button class="btn btn-outline-secondary" role="button" (click)="swap(alertloop.steps,i,(i+1))" *ngIf="i < alertloop.steps.length - 1"><i class="fa fa-arrow-down" aria-hidden="true"></i></button>
                      <button class="btn btn-outline-secondary" role="button" (click)="setEditStepForm(step,i)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                    </div>
                    <div class="collapse" id="collapseStep">
                      <p>test</p>
                    </div>
                  </div>

                  <span><h5>Contact {{step.name}} by {{step.contact}}</h5></span>
                  <span *ngIf="step.use_email"><i class="fa-solid fa-envelope"></i> {{step.email}}<br /></span>
                  <span *ngIf="step.use_phone"><i class="fa-solid fa-phone"></i> {{step.phone}}<br /></span>
                  <span *ngIf="step.use_sms"><i class="fa-solid fa-comment-sms"></i> {{step.cell}}<br /></span>
                  <span *ngIf="step.use_whatsapp"><i class="fa-brands fa-whatsapp"></i> {{step.cell}}<br /></span>
                </li>

                <li class="list-group-item list-group-item-info" *ngIf="i != alertloop.steps.length-1">
                  <i class="fa fa-hourglass" aria-hidden="true"></i>
                  {{ t('Wait') }} {{step.wait}} {{ t('minutes.') }}<br />
                </li>

              </ng-container>

              <li class="list-group-item list-group-item-success">
                <i class="fa fa-hourglass" aria-hidden="true"></i>
                {{ t('Wait') }} {{alertloop.loop_wait}} {{ t('minutes between loops.') }}<br />
                <i class="fa fa-refresh" aria-hidden="true"></i>
                {{ t('Run the Loop') }} {{alertloop.loop_count}} {{ t('time(s)') }}<br />
              </li>

            </ul>
          </c-row>
        </c-card-body>
        </c-card>
      </ng-container>
    </c-container>
  </c-card-body>

  <div class="modal fade" id="addStepModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addStepModalLabel">{{ t('Add a Step to the Alert Loop') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <form [formGroup]="addStepForm" cForm (ngSubmit)="submitAddStepForm()">
            <c-col>
              <div class="form-group row mb-2" >
                <label class="col-sm-4 col-form-label text-end"><svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}</label>
                <div class="col-sm-8">

                  <ng-select [items]="okService.monitors"
                            bindLabel="name"
                            bindValue="id"
                            [multiple]="false"
                            formControlName="user_id">
                  </ng-select>
                  <div *ngIf="submittedAdd && fAdd['user_id'].errors" class="invalid-feedback">
                      {{ t('Please choose a monitor') }}
                  </div>


                </div>
              </div>
            </c-col>
            <c-col>
              <div class="form-group row mb-2" >
                <label class="col-sm-4 col-form-label text-end"><i class="fa fa-hourglass" aria-hidden="true"></i> {{ t('Step Wait Time') }}</label>
                <div class="col-sm-8">

                  <ng-select [items]="loop_wait_times"
                            bindLabel="name"
                            bindValue="value"
                            [multiple]="false"
                            formControlName="wait">
                  </ng-select>
                  <div *ngIf="submittedAdd && fAdd['wait'].errors" class="invalid-feedback">
                      {{ t('Please choose a wait time') }}
                  </div>


                </div>
              </div>
            </c-col>
            <c-row>
              <button cButton class="px-4 text-white btn-info" type="submit" data-dismiss="modal">
                <svg cIcon class="me-2" name="cil-plus"></svg> {{ t('Add the Step') }}
              </button>
            </c-row>
          </form>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="editStepModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editStepModalLabel">{{ t('Add a Step to the Alert Loop') }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="editStepForm" cForm (ngSubmit)="submitEditStepForm()">
          <c-col>
            <div class="form-group row mb-2" >
              <label class="col-sm-4 col-form-label text-end"><svg cIcon name="cil-shield-alt"></svg> {{ t('Monitors') }}</label>
              <div class="col-sm-8">

                <ng-select [items]="okService.monitors"
                          bindLabel="name"
                          bindValue="id"
                          [multiple]="false"
                          formControlName="user_id">
                </ng-select>
                <div *ngIf="submittedEdit && fEdit['user_id'].errors" class="invalid-feedback">
                    {{ t('Please choose a monitor') }}
                </div>


              </div>
            </div>
          </c-col>
          <c-col>
            <div class="form-group row mb-2" >
              <label class="col-sm-4 col-form-label text-end"><i class="fa fa-hourglass" aria-hidden="true"></i> {{ t('Step Wait Time') }}</label>
              <div class="col-sm-8">

                <ng-select [items]="loop_wait_times"
                          bindLabel="name"
                          bindValue="value"
                          [multiple]="false"
                          formControlName="wait">
                </ng-select>


              </div>
            </div>
          </c-col>
          <c-row>
            <button cButton class="px-4 text-white btn-info" type="submit" data-dismiss="modal">
              <svg cIcon class="me-2" name="cil-plus"></svg> {{ t('Edit Step') }}
            </button>
          </c-row>
        </form>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="editLoopModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editLoopModalLabel">{{ t('Edit the Alert Loop Settings') }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">

              <div class="form-group row mb-2" >
                <label class="col-sm-4 col-form-label text-end"><svg cIcon name="cil-reload"></svg> {{ t('Name') }}</label>
                <div class="col-sm-8">
                  <input
                    [formControlName]="'name'"
                    cFormControl
                    placeholder="{{ t('Name') }}"
                    [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                  />
                  <div *ngIf="submitted && f['name'].errors" class="invalid-feedback">
                      {{ t('A valid name is required') }}
                  </div>
                </div>
              </div>
              <div class="form-group row mb-2" >
                <label class="col-sm-4 col-form-label text-end"><i class="fa fa-hourglass" aria-hidden="true"></i> {{ t('Loop Wait') }}</label>
                <div class="col-sm-8">
                  <ng-select [items]="loop_wait_times"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="loop_wait"
                            placeholder="{{ t('Loop Wait') }}">
                  </ng-select>
                </div>
              </div>
              <div class="form-group row mb-2" >
                <label class="col-sm-4 col-form-label text-end"><i class="fa fa-refresh" aria-hidden="true"></i> {{ t('Loop Count') }}</label>
                <div class="col-sm-8">
                  <ng-select [items]="loop_run_count"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="loop_count"
                            placeholder="{{ t('Loop Count') }}">
                  </ng-select>
                </div>
              </div>
            <button cButton class="px-4 text-white btn-info" type="submit">
              <i class="fa-solid fa-check"></i> {{ t('Update Alert Loop') }}
            </button>
        </form>
      </div>
    </div>
  </div>
</div>
</c-card>

